let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jxqpM")).then(() => parcelRequire('95dZm'));